/** Ayarlar > Mail Şablonları uçlarının yanıtları. Hepsi { isSuccess, message, data } kalıbında. */

export interface GetMailSablonuListResponseItem {
    mailSablonuId: string
    kod: string
    ad: string
    konu: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetMailSablonuListResponseData {
    items: GetMailSablonuListResponseItem[]
    totalRecordCount: number
}

export interface GetMailSablonuListResponse {
    isSuccess: boolean
    message: any
    /** Sayfalı yanıt ({ items, totalRecordCount }); sunucu düz dizi dönerse ekran onu da kabul eder. */
    data: GetMailSablonuListResponseData | GetMailSablonuListResponseItem[]
}

export const initialGetMailSablonuListResponseData: GetMailSablonuListResponseData = {
    items: [],
    totalRecordCount: 0
}

export interface MailSablonuDegisken {
    /** Gövdede {{Ad}} olarak yazılır. */
    ad: string
    aciklama: string
    ornek: string
}

export interface GetMailSablonuByIdResponseData {
    mailSablonuId: string
    kod: string
    ad: string
    konu: string
    govde: string
    degiskenler: MailSablonuDegisken[]
}

export interface GetMailSablonuByIdResponse {
    isSuccess: boolean
    message: any
    data: GetMailSablonuByIdResponseData
}

/** Onizle ve VarsayilanaDon yanıtı: konu + gövde. */
export interface MailSablonuIcerikResponse {
    isSuccess: boolean
    message: any
    data: { konu: string, govde: string }
}

/** UpdateMailSablonu, DenemeGonder ve Excel yanıtı (Excel'de data = dosya adı). */
export interface MailSablonuMesajResponse {
    isSuccess: boolean
    message: any
    data: any
}
